//This class will load the steps with the help of steps loader and then update the sim when there is any progress

// import stepLoader from "../helpers/stepsLoader";
import stepLoader from "../helpers/stepsLoader";
import SimManager from "./simManager";
import { Objective, Step, StepInfo } from "../types";
import {
  updateMutatedChapterProgress,
  increamentNotebookProgress,
} from "@learningblocks/exp-redux";

interface NotebookInterface {
  updateTasks(): void;
}

class stepManager {
  private static instance: stepManager;
  private objectivesList: Objective[] = [];
  private objectiveIndex = 0;
  private currentObjective!: Objective;
  private focusedObjectiveIndex = 0;
  private taskNotebook?: NotebookInterface;
  private currentStep = -1;
  private objectivesComplete = false;
  private dispatch: (action: unknown) => void;

  private constructor() {
    this.currentStep = 0;
    this.dispatch = () => {
      console.warn("Dispatch function is not set.");
    };
  }

  setDispatch(dispatch: (action: unknown) => void) {
    this.dispatch = dispatch;
  }

  static getInstance(): stepManager {
    if (!this.instance) this.instance = new stepManager();
    return this.instance;
  }

  registerNotebook(reference: NotebookInterface) {
    this.taskNotebook = reference;
    this.taskNotebook.updateTasks();
  }

  setCurrentStep(stepNumber: number) {
    this.currentStep = stepNumber;
    this.objectivesList.forEach((objective) => {
      objective.steps.forEach((step) => {
        if (step.stepID != this.currentObjective.steps[this.currentStep].stepID)
          step.current = false;
        else step.current = true;
      });
    });
    if (this.taskNotebook) this.taskNotebook.updateTasks();
  }

  setCurrentObjective(objective: Objective) {
    this.currentObjective = objective;
  }

  // eslint-disable-next-line
  loadObjectives(stepsData: any) {
    // this.objectivesList = stepLoader.getInstance().loadData();
    this.objectivesList = stepLoader.getInstance().loadDatafromJson(stepsData);
    this.loadFirstObjective();
  }

  loadFirstObjective(): boolean {
    this.currentObjective = this.objectivesList[0];
    this.focusedObjectiveIndex = 0;
    this.currentStep = 0;
    // eslint-disable-next-line
    setTimeout(() => {
      SimManager.getInstance().saveRestartSnapshot(
        this.currentObjective.steps[this.currentStep].stepID
      );
    }, 1500);
    this.currentObjective.steps[this.currentStep].current = true;
    return true;
  }

  getAllObjectives(): Objective[] {
    return this.objectivesList;
  }

  loadNextObjective(): boolean | null {
    if (this.objectivesList.length > this.objectiveIndex + 1) {
      this.objectiveIndex = this.objectiveIndex + 1;
      this.focusedObjectiveIndex = this.objectiveIndex;
    } else {
      this.handleObjectivesCompleted();
      return null;
    }

    const realObj = this.objectivesList[this.objectiveIndex];
    this.currentStep = 0;
    realObj.steps[this.currentStep].current = true;
    this.currentObjective = realObj;
    if (this.taskNotebook) this.taskNotebook.updateTasks();
    return true;
  }

  updateAllObjectives(steps: StepInfo[]) {
    this.objectivesList.forEach((objective) => {
      steps.map((step) => {
        const searchStep = objective.steps.find(
          (objStep) => objStep.stepID === step.stepID
        );
        if (searchStep) {
          searchStep.completed = step.complete;
          searchStep.wrong = step.wrong;
        }
      });
    });
  }

  getRealObjective() {
    //Check the objectives array to find the step that has currentStep as current
    const realObjective = this.objectivesList.find((objective) => {
      return objective.steps.some((step) => step.current);
    });

    if (realObjective) {
      this.objectiveIndex = this.objectivesList.indexOf(realObjective);
      return realObjective;
    } else return null;
  }

  getRealObjectiveIndex() {
    //Find the index of the real objective in the objectivesList
    const realObjective = this.getRealObjective();
    if (!realObjective) return -1;

    return this.objectivesList.indexOf(realObjective);
  }

  //Gets the next objective
  getNextObjective() {
    const realObjective = this.getRealObjective();
    if (!realObjective) return null;

    const nextObjectiveIndex = this.objectivesList.indexOf(realObjective) + 1;
    if (nextObjectiveIndex < this.objectivesList.length) {
      return this.objectivesList[nextObjectiveIndex];
    }
    return null;
  }

  checkStepsCompleted() {
    /* The goal is that 
    If the current step in the current objective is not requuired, it should check the next step and keep checking until a required step is found. 
    If any step is condition is met for an optional or required step, the proper processing should occur and all skipped steps should be marked properly. 
    If the last step of an objective is optional, the next objective should be checked */

    let realObjective = this.getRealObjective();

    //Check if the conditions are met for the current step
    if (!realObjective) {
      console.error("No current objective found.");
      return;
    }

    const currentStep = realObjective.steps.findIndex((step) => step.current);

    const MarkStepSkipped = (step: Step) => {
      SimManager.getInstance().saveRestartSnapshot(step.stepID);
      step.wrong = true;
      step.current = false;
    };

    if (this.checkStepCompleted(realObjective.steps[currentStep])) {
      realObjective.steps[currentStep].completed = true;
      realObjective.steps[currentStep].current = false;
      if (this.checkObjectiveCompleted(currentStep, realObjective)) {
        this.loadNextObjective();
      } else {
        if (realObjective.steps.length > currentStep + 1) {
          realObjective.steps[currentStep + 1].current = true;
          this.currentStep++;
          this.checkStepsCompleted();
          if (realObjective) {
            this.currentObjective = realObjective;
          }
        } else {
          console.warn("No next step found");
        }
      }
    } else {
      // If the current step is not completed, check if it is required
      if (!this.checkStepRequired(realObjective.steps[currentStep])) {
        let skipOffset = 0;
        let nextStep = currentStep;
        let continueLoop = true;
        const skippedSteps: Step[] = [];

        while (continueLoop) {
          nextStep = currentStep + skipOffset;
          if (!realObjective) {
            console.error("No real objective found.");
            return;
          }

          // Check the next step similar to the first step and repeat until a required step is found
          if (
            nextStep >= realObjective.steps.length &&
            this.checkStepRequired(realObjective.steps[nextStep - 1])
          ) {
            continueLoop = false;
            break;
          }

          if (
            !this.checkStepRequired(realObjective.steps[nextStep]) &&
            nextStep == realObjective.steps.length - 1
          ) {
            skippedSteps.push(realObjective.steps[nextStep]);
            realObjective = this.getNextObjective();
            nextStep = 0;
            skipOffset = 1;
          }

          if (!realObjective) {
            console.error("No real objective found.");
            return;
          }

          if (this.checkStepCompleted(realObjective.steps[nextStep])) {
            skippedSteps.forEach((step) => {
              MarkStepSkipped(step);
            });
            realObjective.steps[nextStep].completed = true;
            realObjective.steps[nextStep].current = false;
            if (this.checkObjectiveCompleted(nextStep, realObjective)) {
              this.loadNextObjective();
            }
            if (realObjective.steps.length > nextStep + 1) {
              realObjective.steps[nextStep + 1].current = true;
              this.currentStep = nextStep + 1;
              if (realObjective) {
                this.currentObjective = realObjective;
              }
            }
            continueLoop = false;
          } else if (!this.checkStepRequired(realObjective.steps[nextStep])) {
            // If the next step is not required, skip it
            skipOffset++;
            nextStep = currentStep + skipOffset;
            //Add current step to skipped steps
            skippedSteps.push(realObjective.steps[currentStep]);
          } else {
            // If the next step is required, break the loop
            continueLoop = false;
          }
        }
      }
    }

    if (this.taskNotebook) this.taskNotebook.updateTasks();
  }

  getCountofAllCompletedSteps(): number {
    let completedSteps = 0;
    this.objectivesList.forEach((objective) => {
      objective.steps.forEach((step) => {
        if (step.completed) {
          completedSteps++;
        }
      });
    });
    return completedSteps;
  }

  checkObjectiveCompleted(
    stepCompleted: number,
    objective: Objective
  ): boolean {
    // eslint-disable-next-line
    setTimeout(() => {
      SimManager.getInstance().saveSnapshot(
        objective.steps[stepCompleted].stepID
      );
      const completedSteps = this.getCountofAllCompletedSteps();
      const menuParams = { menu: "PROTOCOL", menuProgress: completedSteps };

      if (this.dispatch) {
        try {
          this.dispatch(updateMutatedChapterProgress(menuParams));

          this.dispatch(increamentNotebookProgress());
        } catch (error) {
          console.error("Error in dispatch:", error);
        }
      }
    }, 500);

    if (stepCompleted + 1 == objective?.steps.length) {
      return true;
    }
    return false;
  }

  checkStepCompleted(step: Step) {
    const element = step;
    if (!element) return false;
    let totalConditions = 0,
      completedConditions = 0,
      conditionCheck = null,
      hasConditionRelation = false;

    //Check if the step is complete according to the conditions
    element.conditions.forEach((condition) => {
      if (condition.conditionRelation || hasConditionRelation) {
        hasConditionRelation = true;
        totalConditions++;
        const conditionMet = SimManager.getInstance().checkCondition(condition);
        if (condition.conditionRelation == "AND" && !conditionMet) {
          return;
        }
        if (conditionMet) {
          completedConditions++;
        }
      } else {
        if (condition.conditionCheck == "AND") conditionCheck = "AND";
        else if (condition.conditionCheck == "OR") conditionCheck = "OR";

        totalConditions++;

        if (SimManager.getInstance().checkCondition(condition)) {
          completedConditions++;
        }
      }
    });
    if (hasConditionRelation) {
      if (totalConditions > 0 && completedConditions > 0) {
        return true;
      }
      return false;
    } else {
      if (
        (conditionCheck == "AND" && totalConditions == completedConditions) ||
        (conditionCheck != "AND" && completedConditions > 0)
      ) {
        return true;
      }
      return false;
    }
  }

  checkStepRequired(step: Step) {
    return step.required;
  }

  getCurrentStep() {
    return this.currentStep;
  }

  handleObjectivesCompleted() {
    this.objectivesComplete = true;
  }

  getCurrentObjective() {
    return this.currentObjective;
  }

  getCurrentObjectiveIndex() {
    return this.objectivesList.indexOf(this.currentObjective);
  }

  getObjectiveIndex() {
    return this.focusedObjectiveIndex;
  }

  setObjectiveIndex(index: number) {
    this.focusedObjectiveIndex = index;
  }

  setObjectiveByIndex(index: number): boolean {
    if (index < 0 || index >= this.objectivesList.length) {
      return false; // Index is out of bounds
    }
    this.objectiveIndex = index;
    this.currentObjective = this.objectivesList[this.objectiveIndex];
    if (this.taskNotebook) {
      this.taskNotebook.updateTasks(); // Update tasks if the notebook is registered
    }
    return true;
  }
}

export default stepManager;
